<template>
  <div class="no-data-layout">
    <img id="no-data-img" src="@/assets/images/no-data.png" />
    <span id="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '抱歉，暂无符合条件的产品'
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data-layout {
  width: fit-content;
  margin: auto;
  @include displayCenter();
  flex-direction: column;
}
#no-data-img {
  height: 200px;
}
#text {
  @include text-20-400;
  color: #666;
  font-size: 14px;
}
</style>
